/* ==========================================================================
   Second Coat — Shopify Theme JS
   Upload to: Shopify Admin → Themes → Edit code → Assets
   Reference in theme.liquid before </body>:
     <script src="{{ 'second-coat.js' | asset_url }}" defer></script>
   ========================================================================== */

(function () {
  'use strict';

  /* --------------------------------------------------------------------------
     City Ticker — live 24-hour times, synced to top of minute
     -------------------------------------------------------------------------- */
  var CITIES = [
    { label: 'TORONTO',  tz: 'America/Toronto' },
    { label: 'NEW YORK', tz: 'America/New_York' },
    { label: 'LONDON',   tz: 'Europe/London'   },
    { label: 'LAGOS',    tz: 'Africa/Lagos'    },
    { label: 'BEIRUT',   tz: 'Asia/Beirut'     },
    { label: 'BERLIN',   tz: 'Europe/Berlin'   },
    { label: 'TOKYO',    tz: 'Asia/Tokyo'      },
    { label: 'SHANGHAI', tz: 'Asia/Shanghai'   },
  ];

  function getCityTime(tz) {
    return new Intl.DateTimeFormat('en-GB', {
      timeZone: tz,
      hour: '2-digit',
      minute: '2-digit',
      hour12: false
    }).format(new Date());
  }

  function updateCityTimes() {
    var els = document.querySelectorAll('[data-city-tz]');
    els.forEach(function (el) {
      var tz = el.getAttribute('data-city-tz');
      var label = el.getAttribute('data-city-label');
      el.textContent = label + '\u00A0' + getCityTime(tz);
    });
  }

  function initTicker() {
    if (!document.querySelector('[data-city-tz]')) return;
    updateCityTimes();
    var now = new Date();
    var msToNext = (60 - now.getSeconds()) * 1000 - now.getMilliseconds();
    setTimeout(function () {
      updateCityTimes();
      setInterval(updateCityTimes, 60000);
    }, msToNext);
  }

  /* --------------------------------------------------------------------------
     Hero — crossfade panel switcher
     -------------------------------------------------------------------------- */
  function initHero() {
    var section = document.querySelector('.sc-hero');
    if (!section) return;

    var panels = section.querySelectorAll('.sc-hero__panel');
    var dots   = section.querySelectorAll('.sc-hero__dot');
    var codeEl = section.querySelector('.sc-hero__meta--code');
    var codes  = [];

    panels.forEach(function (p) { codes.push(p.getAttribute('data-code') || ''); });

    var active = 0;

    function setActive(idx) {
      panels.forEach(function (p, i) {
        p.classList.toggle('is-active', i === idx);
      });
      dots.forEach(function (d, i) {
        d.classList.toggle('is-active', i === idx);
        /* Height-based indicator for vertical right-side dots */
        d.style.height = i === idx ? '18px' : '4px';
        d.style.background = i === idx
          ? 'rgba(247,241,230,0.50)'
          : 'rgba(247,241,230,0.15)';
      });
      if (codeEl) codeEl.textContent = codes[idx] || '';
      active = idx;
    }

    dots.forEach(function (dot, i) {
      dot.addEventListener('click', function () { setActive(i); });
    });

    setActive(0);
    setInterval(function () {
      setActive((active + 1) % panels.length);
    }, 5500);
  }

  /* --------------------------------------------------------------------------
     Product Families — scene label tracker
     Reads frame count and duration from data attributes, syncs with CSS animation
     -------------------------------------------------------------------------- */
  function initSceneTrackers() {
    var chapters = document.querySelectorAll('[data-sc-chapter]');

    chapters.forEach(function (chapter) {
      var frameCount    = parseInt(chapter.getAttribute('data-frame-count'), 10) || 5;
      var frameDurationMs = 5000; // Must match FRAME_DURATION in CSS animation
      var sceneEls      = chapter.querySelectorAll('.sc-chapter__scene');
      var counterEl     = chapter.querySelector('.sc-chapter__counter');
      var start         = Date.now();

      function update() {
        var elapsed = Date.now() - start;
        var activeIdx = Math.floor(elapsed / frameDurationMs) % frameCount;

        sceneEls.forEach(function (s, i) {
          s.classList.toggle('is-active', i === activeIdx);
        });

        if (counterEl) {
          var label = sceneEls[activeIdx]
            ? sceneEls[activeIdx].getAttribute('data-scene-label') || ''
            : '';
          counterEl.textContent =
            pad(activeIdx + 1) + '/' + pad(frameCount) + '\u00A0\u00A0' + label;
        }
      }

      setInterval(update, 250);
      update();
    });
  }

  function pad(n) {
    return String(n).padStart(2, '0');
  }

  /* --------------------------------------------------------------------------
     Newsletter — Shopify customer email form handling
     Wraps the native Shopify contact form; shows a success state.
     -------------------------------------------------------------------------- */
  function initNewsletter() {
    var form = document.querySelector('.sc-newsletter__form');
    if (!form) return;
    // Shopify handles the POST; on success Liquid sets ?customer_posted=true
    if (window.location.search.indexOf('customer_posted=true') !== -1) {
      var wrap = form.closest('.sc-newsletter');
      if (wrap) {
        var sub = wrap.querySelector('.sc-newsletter__sub');
        if (sub) {
          sub.textContent = 'You\u2019re in. Welcome to the lobby.';
          sub.style.color = 'rgba(247,241,230,0.55)';
        }
        form.style.display = 'none';
      }
    }
  }

  /* --------------------------------------------------------------------------
     Boot
     -------------------------------------------------------------------------- */
  document.addEventListener('DOMContentLoaded', function () {
    initTicker();
    initHero();
    initSceneTrackers();
    initNewsletter();
  });

})();
